export const PaymentType = {
    ChargeBack: 0,
    InternalTransfer: 1,
    MerchantCharges: 2,
    Withdrawal: 3
};
